import { FC } from 'react';
import { parseObjectArrayToString, replaceEmpty } from '@lhb/func';
import { Col } from 'antd';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

/**
 * 动态表单详情-公司成员
 * @description
 * @demo
 */
const Component:FC<{
  label: string;
  textValue: string;
  detailInfoConfig,
}> = ({ label, textValue, detailInfoConfig }) => {

  /* state */

  /* hooks */

  /* methods */
  return (<Col {...detailInfoConfig}>
    <V2DetailItem label={label} value={replaceEmpty(Array.isArray(textValue) ? parseObjectArrayToString(textValue, 'label') : '')} />
  </Col>);
};

export default Component;
